import { IServiceLink } from './interfaces/IServiceLink';

export const creLinks: IServiceLink[] = [
  { name: 'Главная страница', link: '/kommercheskaya-nedvizhimost' },
  { name: 'Сдать недвижимость', link: '/kommercheskaya-nedvizhimost', queryParams: { modal: 'rent' }, },
  { name: 'Арендовать недвижимость', link: '/kommercheskaya-nedvizhimost', queryParams: { modal: 'rentout' }, },
  { name: 'Арендаторам', link: '/kommercheskaya-nedvizhimost/arendatoram' },
  { name: 'Арендодателям', link: '/kommercheskaya-nedvizhimost/arendodatelyam' },
  { name: 'Агентствам', link: '/kommercheskaya-nedvizhimost/agentstvam' },
  { name: 'Тендер', link: '/kommercheskaya-nedvizhimost/tender' },
  { name: 'Тарифы', link: '/tarify' }
];

export const transportLinks: IServiceLink[] = [
  { name: 'Главная страница', link: '/arenda-avto' },
  { name: 'Сдать транспорт', link: '/lk/transport/rent/create', reachGoal: 'clickRazmestitObyavlenie', },
  { name: 'Арендовать транспорт', link: '/arenda-avto' },
];

export const specTransportLinks: IServiceLink[] = [
  { name: 'Главная страница', link: '/arenda-spectehniki' },
  { name: 'Сдать спецтехнику', link: '/lk/com-transport/rent/create', reachGoal: 'clickRazmestitObyavlenie', },
  { name: 'Заявки арендаторов', link: '/arenda-spectehniki/zayavki', new: true },
  { name: 'Арендовать спецтехнику', link: '/arenda-spectehniki' },
];
